import { cn } from "@/shared/lib/cn";
import type { NavigationItem } from "./navigation";

interface NavigationItemContentProps {
  collapsed: boolean;
  item: NavigationItem;
  iconNode: React.ReactNode;
}

export function NavigationItemContent({
  collapsed,
  item,
  iconNode,
}: NavigationItemContentProps) {
  return (
    <>
      <span
        className={cn(
          "flex h-9 w-9 shrink-0 items-center justify-center rounded-full border border-white/10 bg-white/5 text-white/70 transition duration-200",
          "group-data-[status=active]:border-white/40 group-data-[status=active]:bg-white/15 group-data-[status=active]:text-white",
          collapsed && "border-white/20 bg-white/10 text-white/80"
        )}
      >
        {iconNode ?? (
          <span className="text-[0.7rem] font-semibold">{item.abbr}</span>
        )}
      </span>
      {!collapsed ? (
        <div className="flex flex-1 flex-col">
          <span className="font-bold">{item.label}</span>
          {item.description ? (
            <span className="text-xs text-white/40">{item.description}</span>
          ) : null}
        </div>
      ) : (
        <span className="sr-only">{item.label}</span>
      )}
    </>
  );
}
